import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/featureGroup/view/license.featureGroup.plans.query.gql"
import type {
  FeatureGroupPlansQuery,
  FeatureGroupPlansQueryVariables,
} from "@/v2-backoffice-client/license/featureGroup/view/__types__/license.featureGroup.plans.query"

type Options = QueryHookOptions<
  FeatureGroupPlansQuery,
  FeatureGroupPlansQueryVariables
>

export function useFeatureGroupPlansQuery(options?: Options) {
  return useQuery<FeatureGroupPlansQuery, FeatureGroupPlansQueryVariables>(
    query,
    options,
  )
}
